import React from 'react';
import './styles/informations.scss';

function Informations() {
    return (
        <section className='informations-section'>
            <article className='informations-description-wrapper'>
                <h1 className='informations-section-heading'>
                    Discounts <br /> and Sales
                </h1>
                <p className='informations-section-paragraph'>
                    Follow our promotions and discouts. We constantly update
                    them so that you can buy your favorite home products at the
                    best prices. And every Monday a random discout on certain
                    products. Hurry up to buy at an attracitve price.
                </p>
            </article>

            <aside className='pink-vase-wrapper'>
                <div className='pink-vase-description'>
                    <p className='vase-title'>Top Discounts</p>
                    <p className='vase-slogan'>Save up to 50% Off</p>
                    <p className='vase-button'>BUY NOW</p>
                </div>
                <div
                    className='vase-image'
                    style={{
                        backgroundImage: `url('${process.env.PUBLIC_URL}/pinkVase.png')`,
                    }}
                />
            </aside>

            <aside className='yellow-clock-wrapper'>
                <div className='yellow-clock-description'>
                    <p className='clock-title'>Best Selling</p>
                    <p className='clock-slogan'>Wall clocks up to 70% off</p>
                    <p className='clock-button'>BUY NOW</p>
                </div>
                <img
                    className='clock-image'
                    src={`${process.env.PUBLIC_URL}/clockImage.png`}
                    alt='blue clock'
                />
            </aside>

            <div className='newsletter'>
                <h2>Newsletter</h2>
                <p className='newsletter-info'>
                    Stay Updated on all that's new add noteworthy. Join our list{' '}
                    <br /> and get 15% off your first purchase!
                </p>
                <label>
                    <input type='text' placeholder='Email Adress' />
                    <button>Subscribe</button>
                </label>
            </div>
        </section>
    );
}

export default Informations;
